export const HOW_IT_WORKS_VIDEO_URL = 'https://static.cdn-cian.ru/frontend/e2e-form-assets/promo/videos/howItWorks.mp4';
